import React from 'react'
import { ClipLoader } from 'react-spinners'

interface ISkeletonProps {
  className?: string
  text?: string
  withBg?: boolean
  withLoading?: boolean
}

const Skeleton = ({ className = '', text = '', withBg = false, withLoading = true }: ISkeletonProps) => (
  <div
    className={`${className} ${
      withBg ? 'bg-light-grey8' : ''
    } flex flex-column h100 items-center justify-center rp-px16 rp-py32 w100`}
  >
    {withLoading && <ClipLoader size={24} color={'#405264'} loading={true} />}
    {text && <h3 className='font-grey font-light rp-mb0 rp-mt4 text-sm'>{text}</h3>}
  </div>
)

export default Skeleton



// WEBPACK FOOTER //
// ./src/components/riders/rider-portal/common/Skeleton.tsx